import {
  Box,
  Button,
  CssBaseline,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import NavbarComponent from "../component/navbar-component";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";
import html2canvas from "html2canvas";

const boxVariant = {
  visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
  hidden: { opacity: 0, scale: 1 },
};

const BoxAnimate = ({ component }) => {
  // State definition
  const control = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);

  return (
    <motion.div
      className="box"
      ref={ref}
      variants={boxVariant}
      initial="hidden"
      animate={control}
    >
      {component}
    </motion.div>
  );
};

const gabungkanPesanan = (orders) => {
  const map = {};
  let totalQty = 0;

  orders.forEach((item) => {
    const key = Object.keys(item)[0];
    const data = item[key];
    
    const varians = data.order_detail
      .filter(d => d.varian_id)
      .map(d => ({
        varian_id: d.varian_id,
        type: d.type
      }))
      .sort((a, b) => a.varian_id.localeCompare(b.varian_id));

    const addons = data.order_detail
      .filter(d => d.addon_id)
      .map(d => ({
        addon_id: d.addon_id,
        qty: d.max_addon || 1
      }))
      .sort((a, b) => a.addon_id.localeCompare(b.addon_id));

    const signature = JSON.stringify({
      product_name: data.product_name,
      brand: data.brand,
      varians,
      addons
    });

    if (!map[signature]) {
      map[signature] = {
        ...data,
        qty: data.qty || 1,
        varians,
        addons
      };
    } else {
      map[signature].qty += data.qty || 1;
    }

    totalQty += data.qty || 1;
  });

  return {
    items: Object.values(map)
      .sort((a, b) => {
        if (a.product_name !== b.product_name) {
          return a.product_name.localeCompare(b.product_name);
        }

        if (a.brand !== b.brand) {
          return a.brand.localeCompare(b.brand);
        }

        return JSON.stringify(a.varians)
          .localeCompare(JSON.stringify(b.varians));
      })
      .map((data, i) => ({
        [`merged-${i}`]: data
      })),

    totalQty
  };
};

const RingkasanPesanan = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const order_id = params.get("o");
  const [orders, setOrders] = useState([]);
  const [totalItem, setTotalItem] = useState(null);
  const [bio, setBio] = useState({
    order_date: dayjs().format("DD-MM-YYYY"),
    order_person: "[order_person]",
    outletId: "[outletid]",
    phone: "[phone]",
    seat: "4",    
    pack: "25",
    address: "[address]",
    type: "[type]"
  });
  const [loading, setLoading] = useState(true);

  const pageRef = useRef(null);

  // const handleScreenshot = async () => {
  //   if (pageRef.current) {
  //     const canvas = await html2canvas(pageRef.current, { useCORS: true });
  //     const image = canvas.toDataURL("image/png");

  //     // Buat link untuk download gambar
  //     const link = document.createElement("a");
  //     link.href = image;
  //     link.download = `invoice${order_id}.png`;
  //     link.click();
  //   }
  // };

  const handleScreenshot = async () => {
    if (!pageRef.current) return;

    // Tunggu font
    await document.fonts.ready;

    // Tunggu image dalam container
    const images = pageRef.current.querySelectorAll("img");
    await Promise.all(
      Array.from(images).map(img => {
        if (img.complete) return Promise.resolve();
        return new Promise(resolve => {
          img.onload = img.onerror = resolve;
        });
      })
    );

    const canvas = await html2canvas(pageRef.current, {
      useCORS: true,
      scale: 3,
    });

    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = `invoice${order_id}.png`;
    link.click();
  };

  // ====== Use Effect ======
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        const [outletRes, orderRes] = await Promise.all([
          axios.get(`https://script.google.com/macros/s/AKfycbwMR-2Dk9gpd5_KlmhL1Lgk_opPU6OOzb-KJQjizlRtYpKtX_Bp7QWa4i172CDKoRbE/exec?api=outlet`),
          axios.get(`https://script.google.com/macros/s/AKfycbwMR-2Dk9gpd5_KlmhL1Lgk_opPU6OOzb-KJQjizlRtYpKtX_Bp7QWa4i172CDKoRbE/exec?api=order`),
        ]);

        const outletData = outletRes.data.data;
        const raw = orderRes.data.data;

        const rawData = raw.find(item => item.order_id === order_id);

        if (!rawData) return;

        const sOutlet = outletData.filter(ele =>
          ele.outlet_id === parseInt(rawData.outlet_id)
        );

        setBio({
          "Reservation Type": rawData.type,
          Nama: rawData.order_person,
          Kontak: `${rawData.phone}`,
          ...(rawData.type === "catering"
            ? {
                "Tanggal Pengiriman": dayjs(rawData.order_date).format(
                  "DD-MM-YYYY HH:mm"
                ),
                Pack: rawData.pack,
                Address: rawData.address,
              }
            : {
                "Tanggal Reservasi": dayjs(rawData.order_date).format(
                  "DD-MM-YYYY HH:mm"
                ),
                Seat: rawData.seat,
                Outlet: `${sOutlet[0]?.outlet} - ${sOutlet[0]?.address}`,
              }),
        });

        const filteredOrder = rawData.order_details.replace(/^'|'$/g, "");
        // setOrders(JSON.parse(filteredOrder));
        const rawOrders = JSON.parse(filteredOrder) || [];        
        const { items, totalQty } = gabungkanPesanan(rawOrders);
        
        setOrders(items);
        setTotalItem(totalQty);

      } catch (error) {
        console.error("Error fetch data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [order_id]);

  return (
    <div className="body">
      <CssBaseline />
      <BoxAnimate component={<NavbarComponent />} />
      
      <Button fullWidth onClick={handleScreenshot} disabled={loading}>
        Download
      </Button>

      <Grid container justifyContent="center">
        <Grid item xs={11} sm={9} md={7} lg={5}>
          <Paper
            ref={pageRef}
            elevation={6}
            sx={{              
              mx: "auto",
              p: 2,
              mb: 2,
              borderRadius: 3,
              background: "linear-gradient(180deg, #ffffff 0%, #f9fafb 100%)",
            }}
          >
            {/* Header */}
            <Box textAlign="center" mb={2}>
              <Typography variant="h6" fontWeight={800} color="success.main">
                Kabita Group
              </Typography>
              <Typography fontSize=".8em" color="text.secondary">
                Invoice / Ringkasan Pesanan
              </Typography>

              <Divider sx={{ my: 1 }} />

              <Typography fontSize=".75em" color="text.secondary">
                Order ID
              </Typography>
              <Typography fontWeight={700}>{order_id}</Typography>
            </Box>

            {/* Data Pemesan */}
            <Box mb={2}>
              <Typography fontWeight={700} mb={1}>
                Data Pemesan
              </Typography>

              {Object.keys(bio).map((d) => (
                <Grid
                  container
                  key={d}
                  spacing={1}
                  alignItems="center"
                  mb={0.5}
                >
                  <Grid item xs={4}>
                    <Typography
                      color="text.secondary"
                      fontSize=".85em"
                    >
                      {d}
                    </Typography>
                  </Grid>

                  <Grid item xs={8}>
                    <Typography
                      fontWeight={600}
                      textAlign="right"
                      fontSize=".85em"
                    >
                      {bio[d]}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Box>

            <Divider sx={{ my: 1.5 }} />

            {/* Item List */}
            <Box>
              <Typography fontWeight={700} mb={1}>
                Detail Pesanan
              </Typography>

              {orders.map((item) => {
                const data = item[Object.keys(item)];

                return (
                  <Box key={data.product_name} mb={1.5}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography fontWeight={600} fontSize=".9em">
                        {data.product_name}
                      </Typography>
                      <Typography fontWeight={600}>
                        x{data.qty}
                      </Typography>
                    </Box>

                    <Typography fontSize=".75em" color="text.secondary" textTransform="uppercase">
                      {data.brand}
                    </Typography>                

                    {/* List Varian & Addon */}
                    {data.order_detail
                      .filter((ele) => !ele.note && (ele.name || ele.addon_item))
                      .map((ele, i) => (
                        <Typography key={i} fontSize=".75em">                             
                          • {ele.name || ele.addon_item}
                            {(ele.type || ele.addon_type) &&
                            ` (${ele.type || ele.addon_type})`}
                          </Typography>
                        ))}

                    {/* Catatan */}
                    {data.order_detail.find((ele) => ele.note) && (
                      <Box mt={1}>
                        <Typography fontSize=".75em" fontWeight={700}>
                          Catatan:
                        </Typography>
                        <Typography
                          fontSize=".75em"
                          sx={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            overflowWrap: "anywhere",
                          }}
                        >
                          {data.order_detail.find((ele) => ele.note)?.note}
                        </Typography>
                      </Box>
                    )}

                    <Typography textAlign="right" fontWeight={700} mt={0.5}>
                      Rp {data.subtotal.toLocaleString("id-ID")}
                    </Typography>
                  </Box>
                );
              })}
            </Box>

            <Divider sx={{ my: 1.5, borderStyle: "dashed" }} />

            {/* Total */}
             <Box display="flex" justifyContent="space-between">
              <Typography fontWeight={800} fontSize="1.05em">
                {/* TOTAL PEMEASANAN */}
              </Typography>
              <Typography fontWeight={800} fontSize="1em">
                ({totalItem} pesanan)
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between">
              <Typography fontWeight={800} fontSize="1.05em">
                TOTAL
              </Typography>
              <Typography fontWeight={900} fontSize="1.1em" color="success.main">
                Rp{" "}                
                {orders
                  .reduce(
                    (accu, ele) =>
                      accu +
                      ele[Object.keys(ele)].subtotal *
                        ele[Object.keys(ele)].qty,
                    0
                  )
                  .toLocaleString("id-ID")}
              </Typography>
            </Box>

            <Divider sx={{ my: 2 }} />

            {/* Footer */}
            <Box textAlign="center">
              <Typography fontSize=".75em" color="text.secondary">
                Terima kasih atas pesanan Anda 🙏
              </Typography>
              <Typography fontSize=".7em" color="text.secondary">
                Powered by Kabita Group System
              </Typography>
            </Box>
          </Paper>     
        </Grid>
      </Grid>
    </div>
  );
};

export default RingkasanPesanan;
